import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { SingleField } from '@components/text-editors/addons/single-field';
import { NodeStyledFieldMappingTextEditor } from '@components/text-editors/field-mapping-text-editor';
import { useScopedTranslate } from '@locale/translate';

import { NumberPlaceholder, tag, transformInput } from './extensions';

export type FieldMappingNumberFieldProps = BaseFieldMappingFieldProps &
  FieldMappingData & {
    isDecimal?: boolean;
  };

export const FieldMappingNumberField = ({
  defaultValue,
  onChange,
  isDecimal,
  ...rest
}: FieldMappingNumberFieldProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <NodeStyledFieldMappingTextEditor
      extensions={[NumberPlaceholder, SingleField]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag)[0])}
      defaultValue={defaultValue?.value ? transformInput([defaultValue]) : undefined}
      placeholder={t('placeholder')}
      fieldType={isDecimal ? 'decimal' : 'number'}
      disabled
      shouldShowFieldMappingOnFocus
      {...rest}
    />
  );
};

const locale = {
  en: {
    placeholder: 'Select or add',
  },
};
